import {ResolvedPermission} from '../ResolvedPermission'
import type {PermissionItem} from '../../../types/events'
import {DENIED_RESULT_KINDS} from '../../../utils/events/permission-constants'

/** Fields expected on permissionRequest at runtime (MC schema types it as Record<string, never>). */
interface PermissionRequestFields {
  kind?: string
  toolName?: string
  serverName?: string
  description?: string
  detail?: string
}

function isPermissionRequestFields(value: unknown): value is PermissionRequestFields {
  if (typeof value !== 'object' || value === null) return false
  const obj = value as Record<string, unknown>
  if (obj.kind !== undefined && typeof obj.kind !== 'string') return false
  if (obj.toolName !== undefined && typeof obj.toolName !== 'string') return false
  if (obj.serverName !== undefined && typeof obj.serverName !== 'string') return false
  if (obj.description !== undefined && typeof obj.description !== 'string') return false
  if (obj.detail !== undefined && typeof obj.detail !== 'string') return false
  return true
}

/**
 * Renders a resolved denied permission prompt in the timeline.
 */
export function Permission({item}: {item: PermissionItem}) {
  if (!item.completedEvent) return null

  const resultKind = item.completedEvent.data.result?.kind
  if (!resultKind || !DENIED_RESULT_KINDS.has(resultKind)) return null

  const req = item.requestEvent.data.permissionRequest
  if (!isPermissionRequestFields(req)) return null

  return (
    <ResolvedPermission
      kind={req.kind ?? 'unknown'}
      toolName={req.toolName}
      serverName={req.serverName}
      description={req.description}
      detail={req.detail}
      denialKind={resultKind}
    />
  )
}
